import { createContext } from 'react';

import { IFullscreen } from './types';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const FullscreenContext = createContext<IFullscreen>({});

export default FullscreenContext;
